import React from "react";
import PageIntro from "../../components/PageIntro";
import { heroContent } from "./servicesContent";

/**
 * Opening statement of the page: the H1 and the introduction.
 * Sits directly beneath the banner video, which carries no copy of its own.
 * Presentation lives in the shared PageIntro panel; the copy is unchanged.
 */
const ServicesHero = () => (
  <PageIntro
    id="services-hero-heading"
    title={heroContent.h1}
    subtitle={heroContent.subtitle}
    paragraphs={heroContent.paragraphs}
    images={[
      "/assets/intro/certification-compliance.webp",
      "/assets/intro/global-standards.webp",
      "/assets/intro/business-growth.webp",
    ]}
  />
);

export default ServicesHero;
